import { Component, Input, OnInit } from '@angular/core';
import {
  columnTypes,
  IColumnModel,
  ITableConfig,
  PrizeDetails,
} from '@fantaz/shared/data-access/models';
import { SharedUiTableComponentModule } from '@fantaz/shared/ui/table-component';

@Component({
  selector: 'fz-prize-details',
  standalone: true,
  imports: [SharedUiTableComponentModule],
  templateUrl: './prize-details.component.html',
  styleUrls: ['./prize-details.component.scss'],
})
export class TournamentPrizeDetails implements OnInit {
  @Input()
  isLifeExperience: boolean;

  @Input()
  prizeDetails: PrizeDetails[];

  displayedColumns: IColumnModel[] = [];
  configuration: ITableConfig = {
    fixedLayout: true,
    tableName: 'prize-details',
    pagination: {
      paginationTotal: 1,
      sizeQueryParam: 'pageSize',
      indexQueryParam: 'pageIndex',
      paginationSizeOptions: [10],
    },
  };

  ngOnInit() {
    this.displayedColumns = [
      {
        id: 'avatar',
        title: 'Prize',
        type: () => columnTypes.IMG,
        mapping: (element: PrizeDetails) =>
          typeof element.prizeImageAvatar === 'string'
            ? element.prizeImageAvatar
            : element.prizeImageAvatar?.url ?? '',
        tooltip: () => null,
      },
      {
        id: 'rank',
        title: 'Place',
        type: () => columnTypes.DEFAULT,
        mapping: (element: PrizeDetails) => element.rank,
        tooltip: () => null,
      },
      {
        id: 'type',
        title: 'Type',
        type: () => columnTypes.DEFAULT,
        mapping: (element: PrizeDetails) =>
          this.getPrizeType(element.prizeType, element.tangible) ?? 'None',
        tooltip: () => null,
      },
      {
        id: 'dollar_amount',
        title: this.isLifeExperience ? 'Name' : 'Prize',
        type: () =>
          !this.isLifeExperience ? columnTypes.CURRENCY : columnTypes.DEFAULT,
        mapping: (element: PrizeDetails) =>
          this.isLifeExperience ? element.prizeName : element.prizeValue,
        tooltip: () => null,
      },
    ];
    if (!this.isLifeExperience) {
      this.displayedColumns.splice(0, 1);
    }
  }
  getPrizeType(
    type: string | undefined,
    tangible: boolean | undefined,
  ): string | undefined {
    switch (type) {
      case 'CASH_PERCENT':
        return 'Cash';
      case 'CASH_DOLLAR':
        return 'Cash';
      case 'POINTS':
        return 'POINTS';
      case 'LIFE_EXPERIENCE':
        return tangible ? 'Prize' : 'Life Experience';
      case 'FREE':
        return 'FREE';
      default:
        return undefined;
    }
  }
}
